//============================
//# hmmetreport
//============================

import { ValidationRules } from "@/models/Validation";
import { t } from "@/plugins/i18n";

export default interface MetRiportHead {
    id: number;
    name: string;
    foreign: string;
    english: string;
    beginDate: Date | null;
    endDate: Date | null;
    previewBeginDate: Date | null;
    previewEndDate: Date | null;
    status: number;
}

export const MetRiportHeadDefaultProps: MetRiportHead = {
    id: 0,
    name: "",
    foreign: "",
    english: "",
    beginDate: new Date(),
    endDate: null,
    previewBeginDate: new Date(),
    previewEndDate: null,
    status: 2,
}

export const MetRiportHeadValidationRules: ValidationRules = {
    name: [
        (v: string) => !!v || t("Kotelezo"),
        (v: string) => v.replace(/\s+/g, "").length >= 1 || t("NemLehetRovidebbMintEgyKarakter")
    ],
    //Kezdő és végdátum validáció csak backenden
}